import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';

class IfengWuXian extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const { content } = this.props;

        return <div className={styles.contIntro} dangerouslySetInnerHTML={{ __html: content.productsLeft2 }} />;
    }
}

export default IfengWuXian;
